export default __webpack_public_path__ + "static/media/general-information.01708e80.svg";